import React, { ReactNode } from 'react';
import styled from 'styled-components';

const Wrap = styled.div<{ $alignRightOnDesktop?: boolean }>`
  padding: 0 16px;
  .isDesktopStyle & {
    padding: 16px 24px;
    border-top: 1px solid var(--elevation-light-border);
    ${({ $alignRightOnDesktop }) =>
      $alignRightOnDesktop
        ? `
        display: flex;
        justify-content: flex-end;
      `
        : ''};
  }
`;

interface Props {
  children?: ReactNode;
  alignRightOnDesktop?: boolean;
}

const ModalFooter = ({ children, alignRightOnDesktop }: Props) => {
  return <Wrap $alignRightOnDesktop={alignRightOnDesktop}>{children}</Wrap>;
};

export default ModalFooter;
